import * as React from "react";
import { Link } from "react-router-dom";

export type PosterCardProps = {
  /** Destination for the poster + title link */
  linkTo: string;
  /** Primary line under the poster (movie title or show name) */
  title: string;
  /** TMDB `poster_path` segment, or empty — falls back to placeholder image */
  posterPath?: string | null;
  /** Secondary line (e.g. `Release: …` or `First air: …`); omitted if empty */
  subtitle?: string;
  /**
   * Optional row edge class for reference parity (`first` / `last`).
   * Omit when column count is responsive — see plan note.
   */
  rowPosition?: "first" | "last";
};

const PosterCard: React.FC<PosterCardProps> = ({
  linkTo,
  title,
  posterPath,
  subtitle,
  rowPosition,
}) => {
  const src =
    posterPath && String(posterPath).length > 0
      ? `https://image.tmdb.org/t/p/w500${posterPath}`
      : "/images/no-image.jpg";

  const articleClass = ["latestPost", "excerpt", rowPosition]
    .filter(Boolean)
    .join(" ");

  const showSubtitle = Boolean(subtitle && subtitle.trim());

  return (
    <article className={articleClass}>
      <Link
        to={linkTo}
        title={title}
        className="post-image post-image-left"
      >
        <div className="featured-thumbnail">
          <img src={src} alt={title} decoding="async" />
        </div>
      </Link>
      <header>
        <h2 className="title front-view-title">
          <Link to={linkTo} title={title}>
            {title}
          </Link>
        </h2>
        {showSubtitle ? (
          <p className="poster-card-subtitle">{subtitle}</p>
        ) : null}
      </header>
    </article>
  );
};

export default PosterCard;
